import React,{useEffect, useState}  from 'react'
import api from '../service/api'

import {fillSvg} from '../scripts/util.js'

import NavBar from '../components/navbar'

import startupIcon from '../images/startup-branco.svg'

import ReactVivus from 'react-vivus';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPhone, faGlobe, faAt, faLink} from '@fortawesome/free-solid-svg-icons'

export default function Empreendedorismo(){
  
  const [startups, setStartups] = useState([])

  useEffect(()=>{
    async function loadStartups(){ 
      const response = await api.get('/open/startups')
      setStartups(response.data)
    }

    loadStartups()
  },[])

  return(
    <div id="empreendedor">
      <NavBar bgColor='rgb(192,81,44)' transparent animate
       navLinks={{
         "Incubação": "#incubacao",
         "Startups": "#startups"
       }}
      />

      <div className="h-100 w-100 text-white" style={{backgroundColor: "rgba(192,81,44,.788)"}, {height: "90%"}}>  
        {/*Apresentação */}
        <div className="text-center h-100 m-0 p-0 row justify-content-center align-items-center" >
            <div className="texto-apresentacao column w-75">
              <p className="font-weight-bold anim-up top-p">
                  Bem vindo ao ambiente de empreendedorismo
              </p>

              <p className="anim-left top-p">
                  Fique por dentro de todos os eventos, as capacitações, 
                  os programas de pré-incubação, incubação e aceleração 
                  de startups disponíveis no campus da UFC - Campus Quixadá
              </p>
            </div>
        </div>
      </div>
      
      {/*incubação */}
      <div id="incubacao" style={{backgroundColor: "rgb(192,81,44)"}}>
        <div className="row  mx-auto text-center" style={{padding: "10%", overflow: "hidden"}}>
            <ReactVivus
                className="col-sm-6 mb-4 mx-auto"
                id="rocket"
                option={{
                  file: startupIcon,
                  animTimingFunction: 'EASE',
                  type: 'oneByOne',
                  duration: 100
                }}
                style={{ height: '200px', width: '200px' }}
                callback={fillSvg}
            />

            <div className="col-sm-6">
                <div className="row text-white justify-content-center align-self-center h-100">
                  <h3 className="mb-3 font-weight-bold">Pré-incubação e incubação de startups</h3>
                  <h5>
                      Fomenta principalmente o desenvolvimento social e econômico da região do Sertão Central buscando
                      retenção de talentos e geração de novos negócios; o INOVE também atua na transferência de tecnologia
                      da universidade para o mercado, aceleração e incubação de empreendimentos nascentes e indução do
                      ecossistema empreendedor regional
                  </h5>
                </div>
            </div>
        </div>
      </div>
      <div id="startups" className="bg-white">
        <h2 className="m-0 p-4 text-center font-weight-bold" style={{color: "rgb(192,81,44)"}}>Nossas startups</h2>

        <div className="row mt-2 mb-5 mx-0 px-0 justify-content-center">

            {startups.length > 0
            ? startups.map((startup, indice) => (
                <div key={startup._id} className="card col-sm-2 mx-3 mt-5 p-0 border-0 shadow-sm">

                  <a href={`/startup/${startup._id}`}>
                    <img data-toggle="modal" height="250px" data-startup={indice} className="card-img-top" src={api.defaults.baseURL + startup.fotoUrl} alt=""/>
                  </a>
                  
                  <div className="card-body">
                    <h5 id="titulo" className="card-title font-weight-bold">{startup.nome}</h5>
                    <p id="descricao" className="card-text">{startup.descricao.substring(0, 225)}...</p>
                  </div>
                  <div className="card-footer">
                          <p className="card-text">
                            <FontAwesomeIcon icon={faPhone} style={{color: "rgb(68, 1, 91)"}} /> {startup.telefone}
                          </p>
                          <p className="card-text">
                            <FontAwesomeIcon icon={faLink} style={{color: "rgb(68, 1, 91)"}} /> {startup.site}
                          </p>
                    </div>
                </div>
            ))
            : <p className="text-center">Não há startups cadastradas.</p>
            }    
          </div>
      </div>
    </div>
  )
}